export const generateEntries = <T> (len:number, method:(i?:number)=>T) : T[] => {
    const arr = [];
    for (let i=0; i<len; i++){
      arr.push( method(i) );
    }
    return arr;
  }